<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="px-5">
            <v-form ref="searchform" v-model="valid">
              <v-row class="ms-1 me-1 py-3">
                <v-col cols="12" md="3" lg="3" xs="12">
                  <v-autocomplete
                    v-model="filter.selectedCountry"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                    :rules="FieldRequired('Country')"
                    @change="getpartnerTypes(filter.selectedCountry)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" lg="3" xs="12">
                  <v-autocomplete
                    v-model="filter.selectedPartner"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Payout partners"
                    item-text="txt"
                    item-value="val"
                    :items="payoutPartner"
                    :rules="FieldRequired('Payout partners')"
                    @change="partnerPaymentMode(filter.selectedPartner)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" lg="3" xs="12">
                  <v-autocomplete
                    v-model="filter.selectedPayment"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="method_options"
                    placeholder="Payment Mode"
                    :rules="FieldRequired('Payment Mode')"
                  ></v-autocomplete>
                </v-col>
                <div class="d-flex">
                  <v-btn
                    depressed
                    small
                    class="text-capitalize me-2 ms-2 text-decoration-none"
                    color="primary"
                    @click="getAllBanks()"
                    >Get Results</v-btn
                  >
                </div>
              </v-row>
            </v-form>
          </v-row>
        </v-card>
      </v-card-text>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="BankSummary"
        :search="search"
        dense
        show-select
        item-key="name"
        v-model="selectedData"
      >
        <template v-slot:item.api_code="{ item }">
          <v-text-field
            :value="item.api_code"
            @input="updateApiCode(item, $event)"
            class="rounded ma-1"
            hide-spin-buttons
            dense
            outlined
            title="Api code"
            hide-details
            placeholder="Api code"
          ></v-text-field>
        </template>
        <template v-slot:item.bank_name="{ item }">
          <v-text-field
            :value="item.bank_name"
            @input="updateBankName(item, $event)"
            class="rounded ma-1"
            hide-spin-buttons
            dense
            outlined
            title="Api descrption"
            hide-details
            placeholder="Api descrption"
          ></v-text-field>
        </template>
        <template v-slot:item.no_of_branches="{ item }">
          <a class="text-decoration-underline" @click="navBranchList(item)">
            {{ item.no_of_branches }}
          </a>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-switch
                v-model="item.is_active"
                height="0px"
                title="Update Status"
                dense
                color="success"
                @change="isactiveupdate(item)"
              ></v-switch>
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="update(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
          </div>
          <!-- <v-badge color="grey" content="1" small shape="circle"> -->
        </template>

        <template v-slot:top>
          <v-row class="ms-3 me-1 mt-3">
            <div class="d-flex">
              <v-btn
                depressed
                small
                class="text-capitalize text-decoration-none me-2"
                color="primary"
                @click="openDialog"
                ><v-icon small class="me-2">mdi-bank-plus</v-icon>Add
                Bank</v-btn
              >
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 text-decoration-none"
                color="primary"
                @click="updateAll()"
                ><v-icon small> mdi-content-save-edit-outline</v-icon>Update
                All</v-btn
              >
            </div>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              class="me-2"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-4"
              dense
              clearable
            ></v-text-field>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="800">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span>{{ formtitle }} Bank Details</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Country
                  </label>
                  <v-autocomplete
                    v-model="bankDetails.country_code"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="country_options"
                    :rules="FieldRequired('Country')"
                    @input="getpartnerTypes(bankDetails.country_code)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Payout Partner
                  </label>
                  <v-autocomplete
                    v-model="bankDetails.partner_id"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="payoutPartner"
                    placeholder="Payout Partner"
                    :rules="FieldRequired('Payout Partner')"
                    @input="partnerPaymentMode(bankDetails.partner_id)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Payment Mode
                  </label>
                  <v-autocomplete
                    v-model="bankDetails.payment_mode"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="method_options"
                    placeholder="Payment Mode"
                    :rules="FieldRequired('Payment Mode')"
                    @change="getAllBanksdropdown()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Banks
                  </label>
                  <v-autocomplete
                    v-model="bankDetails.source_id_list"
                    class="rounded"
                    dense
                    outlined
                    multiple
                    item-text="txt"
                    item-value="val"
                    :items="BankList"
                    placeholder="Banks"
                    :rules="FieldRequired('Banks')"
                  ></v-autocomplete>
                </v-col>
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    justify-content: right;
                    margin-top: 8px;
                    margin-bottom: 8px;
                  "
                >
                  <v-btn
                    depressed
                    color="primary"
                    min-width="170px"
                    class="me-5 text-capitalize"
                    @click="save()"
                  >
                    Add
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    class="text-capitalize"
                    outlined
                    min-width="170px"
                    @click="closeDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                    >Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { FieldRequired } from "@/utils/validation.js";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
import { masterBankandBranch } from "@/utils/validation.js";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      ...masterBankandBranch,
      FieldRequired,
      search: "",
      dialogDelete: false,
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      showDialog: false,
      valid: true,
      editedIndex: -1,
      title_text: "",
      country_options: [],
      method_options: [],
      payoutPartner: [],
      filter: {
        selectedCountry: null,
        selectedPayment: null,
        selectedPartner: null,
      },
      bank_id: null,
      dessertHeaders: [
        {
          text: "Bank Code",
          sortable: false,
          value: "source_id",
        },
        { text: "Bank Name", value: "name" },
        { text: "Payment Mode", value: "payment_mode" },
        { text: "Api code", value: "api_code" },
        { text: "Api description", value: "bank_name" },
        { text: "Action", value: "action", sortable: false },
      ],
      BankSummary: [],
      BankList: [],
      selectedData: [],
      bankDetails: {
        country_code: null,
        payment_mode: null,
        partner_id: null,
        mapping_type: "B",
        is_active: true,
        source_id_list: [],
      },
      updatebankDetails: {
        map_id: null,
        payment_mode: "",
        partner_id: null,
        mapping_type: "B",
        is_active: null,
        api_code: "",
        bank_name: "",
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  mounted() {
    this.getBeneCountryList();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  watch: {
    "bankDetails.country_code"(val) {
      this.country_options.map((ele) => {
        if (ele.val === val) {
          this.bankDetails.country_name = ele.txt;
        }
      });
    },
    "bankDetails.payment_mode"(val) {
      console.log("val", val);
    },
    selectedData(val) {
      console.log("Selected Data value===> ", val);
    },
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.BankSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.BankSummary,
          "bankSummary"
        );
      }
    },
    async getpartnerTypes(country_id) {
      try {
        const response = await partnerService.getAllPayoutPartners(country_id);
        if (response.data.status_code === 200) {
          console.log("response.data.data partner", response.data.data);
          this.payoutPartner = response.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    async isactiveupdate(item) {
      item.is_active ? false : true;
      this.isLoading = true;
      
      try {
        const response = await partnerService.updateStatus({
          partner_id:item.partner_id,
          map_id:[item.map_id],
          is_active:item.is_active
        })
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.getAllBanks()
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },
    async getAllBanks() {
      if (this.$refs.searchform.validate()) {
        try {
          let countryCode = null;
          let paymentMode = null;
          let partnerId = null;
          if (this.showDialog) {
            countryCode = this.bankDetails.country_code;
            paymentMode = this.bankDetails.payment_mode;
            partnerId = this.bankDetails.partner_id;
          } else {
            countryCode = this.filter.selectedCountry;
            paymentMode = this.filter.selectedPayment;
            partnerId = this.filter.selectedPartner;
          }
          const response = await setupService.getPartnerBanks(
            countryCode,
            partnerId,
            paymentMode
          );
          if (response.data.status_code === 200) {
            this.BankSummary = response.data.data;
          } else if (response.data.status_code === 401) {
            this.BankSummary = [];
          } else {
            this.showAlertError(`Failed: ${response.data.message}`);
            this.BankSummary = [];
          }
          console.log("All Banks", response);
        } catch (e) {
          console.error(e);
          this.showAlertError(
            `Failed: Technical Error please try again later.`
          );
          this.BankSummary = [];
        }
      }
    },
    async getAllBanksdropdown() {
      try {
        const countryCode = this.bankDetails.country_code;
        const paymentMode = this.bankDetails.payment_mode;
        const response = await setupService.getAllBanksdropdown(
          countryCode,
          paymentMode
        );
        if (response.data.status_code === 200) {
          this.BankList = response.data.data.map((ele) => {
            return {
              txt: ele.name,
              val: ele.code,
            };
          });
        } else if (response.data.status_code === 401) {
          this.BankList = [];
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.BankList = [];
        }
        console.log("All Banks", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.BankList = [];
      }
    },

    editItem() {
      this.editedIndex = 1;
      // this.getBankById(item.bank_id);
      // this.showDialog = true;
    },
    openDialog() {
      this.resetBankObj();
      this.showDialog = true;
      this.editedIndex = -1;

      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },
    resetBankObj() {
      this.bankDetails = {};
    },

    closeDialog() {
      this.loader = false;
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
    async save() {
      console.log(
        "this.countryCode, this.partnerId, this.paymentMode",
        this.countryCode,
        this.partnerId,
        this.paymentMode
      );
      this.loader = true;
      this.bankDetails.mapping_type = "B";
      if (this.$refs.Addform.validate()) {
        try {
          const response = await setupService.AddBankData(this.bankDetails);
          if (response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            this.getAllBanks();
            this.stoploader();
            this.showDialog = false;
          } else {
            this.showAlertError(response.data.message);
            this.loader = false;
          }
          console.log("saved Data", response);
        } catch (e) {
          console.error(e);
          this.showAlertError(
            `Failed: Technical Error please try again later.`
          );
          this.loader = false;
        }
      }
    },
    updateApiCode(item, value) {
      item.api_code = value.trim();
    },
    // Method to update bank_name property of the item
    updateBankName(item, value) {
      item.bank_name = value.trim();
    },
    async update(data) {
      this.loader = true;
      try {
        const response = await setupService.updateBankData([data]);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.selectedData = [];
          this.getAllBanks();
          this.showDialog = false;
          this.stoploader();
        } else {
          this.showAlertError(response.data.message);
        }
        console.log("Multiple update Data", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
      }
    },
    async updateAll() {
      if (this.selectedData.length > 0) {
        this.loader = true;
        try {
          const response = await setupService.updateBankData(this.selectedData);
          if (response.data.status_code === 200) {
            this.showAlertSuccess(response.data.message);
            this.selectedData = [];
            this.getAllBanks();
            this.showDialog = false;
            this.stoploader();
          } else {
            this.showAlertError(response.data.message);
          }
          console.log("Multiple update Data", response);
        } catch (e) {
          console.error(e);
          this.showAlertError(
            `Failed: Technical Error please try again later.`
          );
        }
      }
    },
    async getPaymentMode() {
      this.loader = true;
      this.bankDetails.country_code
        ? (this.selectedCountry = this.bankDetails.country_code)
        : "";
      const selectedCountry = this.country_options.find(
        (item) => item.val === this.bankDetails.country_code
      );
      selectedCountry
        ? (this.bankDetails.country_name = selectedCountry.txt)
        : "";
      console.log(this.bankDetails.country_name);
      try {
        const responseData = await setupService.getPaymentByCountry(
          this.selectedCountry
        );
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.method_options = responseData.data.data.map((i) => {
            return {
              txt: i.payment_mode.value,
              val: i.payment_mode.value_code,
            };
          });
        } else {
          this.method_options = [];
        }
        console.log("getPaymentMode", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },

    async partnerPaymentMode(partner_id) {
      try {
        this.loader = true;
        const response = await partnerService.getPartnerPaymentMode(partner_id);
        if (response.data.status_code === 200) {
          this.loader = false;
          this.method_options = response.data.data[0].map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
        } else {
          this.method_options = [];
          this.loader = false;
        }
        console.log("Payment Modes", response);
      } catch (e) {
        console.error(e);
        this.loader = false;
        console.error(e);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
